import React, { Component } from 'react';
import * as _ from 'lodash';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import { extractErrorMessage } from '../utilities/commonUtil';
import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';
import Helmet from 'react-helmet';
import LocalStorageService from '../services/utilities/LocalStorageService';

import { WorkerHeader } from '../components/worker/header/WorkerHeader';
import { WorkerImageForm } from '../components/worker/form/WorkerImageForm';
import Information from '../components/modals/common/Information';
import Confirmation from '../components/modals/common/Confirmation';

import {
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  FACE_PICTURE_UPLOAD_STATUS,
  HEADER_CONSTANTS,
} from '../utilities/constants';
import { MasterPageHeader } from '../components/PageHeader';
import UserApi from '../services/user/UserApi';
import FaceImageService from '../services/spotWorkers/faceImage/FaceImageService';
import FaceImageApi from '../services/spotWorkers/faceImage/FaceImageApi';

/**
 * @description アカウント詳細・編集(顔写真時)
 */
export class UserProfilePhoto extends Component {
  state = {
    header: {
      // アカウント基本情報ヘッダー用プロパティ
      LinkButtonObject: {}, // 閉じるリンク (内容はbuttonObject)
      buttonObject: {}, // ボタン内容 (内容はbuttonObject)
    },
    headerButtonObject: {
      // ヘッダーで必要なモデル (詳細はWorkerHeader.jsxを参照)
      label: data.defaultButton.label, // テキスト
      className: data.defaultButton.className, // クラス名
      onClick: null, // 処理
    },
    workerImage: {
      imageUrl: '',
      imageBinary: null,
      imageName: '',
      uploadStatus: FACE_PICTURE_UPLOAD_STATUS.notChangedFile.id,
      isInitFile: true,
    },
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    informationModal: {
      // インフォメーションモーダル用プロパティ (ボタン1つ)
      message: null, // モーダルダイアログのメッセージ
    },
    pageStatus: WORKER_PAGE_STATUS.CONFIRM,
    spotWorkerId: null,
    isLoading: false,
    selectedTabId: '',
  };

  constructor(props) {
    super(props);

    this.updatingFlag = false; // 多重更新防止Flag

    // タイトル名
    this.TITLE_NAME = 'アカウント詳細・編集';

    this.userId = LocalStorageService.getUserId();
    this.roleId = LocalStorageService.getRoleId();

    this.events = {};

    // WorkerImage.jsxに渡すイベント
    this.events.setValueWorkerImage = this.setValueWorkerImage.bind(this);

    this.state = this.resetHeader(this.state);
  }

  fetchImage = async () => {
    let stateChange = {
      workerImage: {
        imageUrl: '',
        imageBinary: null,
        imageName: '',
        uploadStatus: FACE_PICTURE_UPLOAD_STATUS.notChangedFile.id,
        isInitFile: false,
      },
      spotWorkerId: null,
    };
    try {
      const response = await UserApi.faceImage(this.userId);
      if (response.result) {
        stateChange.workerImage.imageUrl =
          response.data.worker_thumbnail_image_url;
        stateChange.spotWorkerId = response.data.spot_worker_id;
      }
    } finally {
      this.setState(stateChange);
    }
  };

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    await this.fetchImage();
  }

  /**
   * =====================================================
   * ヘッダー周りの処理 - START
   * =====================================================
   */

  /**
   * ヘッダーをリセットする
   * @param {object} state: ステート
   * */
  resetHeader = state => {
    state.header = {
      LinkButtonObject: {},
      buttonObject: {},
    };
    switch (state.pageStatus.ID) {
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        state = this.createObjectForMoveBack(state);
        state = this.createConfirmPageHeaderButton(state);
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        state = this.createObjectForMoveBack(state);
        state = this.createEditPageHeaderButton(state);
        break;
      default:
        break;
    }
    return state;
  };

  /**
   * buttonObjectを初期化する
   * @param {object} state: ステート
   * */
  clearButtonObject = state => {
    state.headerButtonObject.label = data.defaultButton.label;
    state.headerButtonObject.className = data.defaultButton.className;
    state.headerButtonObject.onClick = null;
    return state;
  };

  /**
   * 閉じるためのリンクを作成する
   * @param {object} state: ステート
   * */
  createObjectForMoveBack = state => {
    state.headerButtonObject.label = data.buttonLink.label;
    state.headerButtonObject.className = data.buttonLink.defaultClassName;
    state.headerButtonObject.onClick = this.handlerMoveBack.bind(this);
    state.header.LinkButtonObject.moveBack = _.cloneDeep(
      state.headerButtonObject
    );
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 詳細画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createConfirmPageHeaderButton = state => {
    // 編集ボタン作成
    state.headerButtonObject.label = data.header.confirm.button.edit.label;
    state.headerButtonObject.className =
      data.header.confirm.button.edit.className;
    state.headerButtonObject.onClick = this.moveToEdit.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 編集画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createEditPageHeaderButton = state => {
    // 編集をやめるボタン作成
    state.headerButtonObject.label = data.header.edit.button.cancel.label;
    state.headerButtonObject.className =
      data.header.edit.button.cancel.className;
    state.headerButtonObject.onClick = this.showCancelEditDialog.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 更新ボタン作成
    state.headerButtonObject.label = data.header.edit.button.update.label;
    state.headerButtonObject.isSetDisabled = true;
    state.headerButtonObject.className =
      data.header.edit.button.update.className;
    state.headerButtonObject.onClick = this.updateWorkerImage.bind(this);
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 閉じるリンクをクリックした時の処理
   * */
  handlerMoveBack = () => {
    switch (this.state.pageStatus.ID) {
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveBack();
        break;
      default:
        break;
    }
  };

  /**
   * タブをクリックした時の処理
   * */
  handlerUserTabClick = selectedTabId => {
    switch (this.state.pageStatus.ID) {
      // 編集中の場合はタブ移動ダイヤログを表示
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog(selectedTabId);
        break;

      // 詳細確認そのまま移動
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        _masterSlideLoader.show(selectedTabId, {
          state: { id: this.state.userId },
        });
        break;
      default:
        break;
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * アカウント一覧画面に遷移する
   */
  moveBack = () => {
    _masterSlideLoader.close();
  };

  /**
   * 顔写真詳細画面に遷移する
   */
  moveToConfirm = (reloadImage = false) => {
    this.setState(
      state => {
        state.pageStatus = WORKER_PAGE_STATUS.CONFIRM;
        if (reloadImage) {
          state.workerImage.imageUrl = '';
        }
        state = this.resetHeader(state);
        return state;
      },
      () => this.closeDialog()
    );

    if (reloadImage) {
      this.fetchImage();
    }
  };

  /**
   * 顔写真編集画面に遷移する
   */
  moveToEdit = () => {
    this.setState(
      state => {
        state.pageStatus = WORKER_PAGE_STATUS.EDIT;
        state = this.resetHeader(state);
        return state;
      },
      () => this.closeDialog()
    );
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.message = null;
    this.setState(state);
  };

  /**
   * 編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.cancelEditDialogEnabled.id;
    this.setState(state);
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = selectedTabId => {
    this.setState({
      dialogStatus: DIALOG_STATUS.leaveThisPageDialogEnabled.id,
      selectedTabId,
    });
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * API周りの処理 - START
   * =====================================================
   */

  /**
   * アカウント顔写真登録・更新
   */
  updateWorkerImage() {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const state = { ...this.state };
    const formData = FaceImageService.createUpdateFaceImage(
      Object.assign(state.workerImage, {
        userId: this.userId,
      })
    );
    FaceImageApi.updateFaceImage(formData)
      .then(response => {
        if (response.result === true) {
          this.updatingFlag = false;
          state.dialogStatus = DIALOG_STATUS.updateSuccessDialogEnabled.id;
          this.setState(state);
          return;
        }

        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(response);
        this.updatingFlag = false;
        this.setState(state);
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(error);
        this.updatingFlag = false;
        this.setState(state);
      });
  }

  /**
   * =====================================================
   * API周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   *フォーム周りの処理 - START
   * =====================================================
   */

  /**
   * 顔写真情報をセット
   */
  setValueWorkerImage(value) {
    if (isNullOrUndefinedOrEmptyStr(value) === false) {
      const state = _.cloneDeep(this.state);
      if (value.imageUrl !== null) {
        state.workerImage.imageUrl = value.imageUrl;
      }
      if (value.imageBinary !== null) {
        state.workerImage.imageBinary = value.imageBinary;
      }
      if (value.imageName !== null) {
        state.workerImage.imageName = value.imageName;
      }
      if (value.isInitFile !== null) {
        state.workerImage.isInitFile = value.isInitFile;
      }
      state.workerImage.uploadStatus = value.uploadStatus;
      this.setState(state);
    }
  }

  /**
   * =====================================================
   * フォーム周りの処理 - END
   * =====================================================
   */

  render() {
    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {this.TITLE_NAME}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            dataTestId={'user-profile-photo'}
            title={this.TITLE_NAME}
            onClose={() => this.handlerMoveBack()}
          />

          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <SideMenu handlerUserTabClick={this.handlerUserTabClick} />

              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <WorkerHeader
                  LinkButtonObject={this.state.header.LinkButtonObject}
                  buttonObject={this.state.header.buttonObject}
                  errorMessagesCount={0}
                  isDisabled={this.state.workerImage.isInitFile}
                />

                <div className='contruction-detail-view__bar' />

                <WorkerImageForm
                  events={this.events}
                  workerImage={this.state.workerImage}
                  showEditButton={
                    this.state.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID
                  }
                  showDeleteButton={
                    this.state.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID
                  }
                  pageExplanation={data.pageExplanation}
                />

                {/* 更新失敗時のダイアログ */}
                <Information
                  visible={
                    this.state.dialogStatus ===
                    DIALOG_STATUS.updateFailedDialogEnabled.id
                  }
                  title={messageUtility.getMessage('E-000-005')}
                  message={this.state.informationModal.message}
                  buttonText={messageUtility.getMessage('I-000-008')}
                  onClose={() => this.closeDialog()}
                />

                {/* 更新成功時のダイアログ */}
                <Information
                  visible={
                    this.state.dialogStatus ===
                    DIALOG_STATUS.updateSuccessDialogEnabled.id
                  }
                  title={data.successDialog.title}
                  message={data.successDialog.message}
                  buttonText={data.successDialog.buttonText}
                  onClose={() => this.moveToConfirm()}
                />

                {/* 編集をやめる時のダイアログ */}
                <Confirmation
                  visible={
                    this.state.dialogStatus ===
                    DIALOG_STATUS.cancelEditDialogEnabled.id
                  }
                  title={messageUtility.getMessage('I-000-025')}
                  confirmButtonText={messageUtility.getMessage('I-000-025')}
                  cancelButtonText={messageUtility.getMessage('I-000-008')}
                  message={messageUtility.getMessage('I-000-050')}
                  isNegative
                  onConfirm={() => this.moveToConfirm(true)}
                  onCancel={() => this.closeDialog()}
                />

                {/* 閉じる時/タブ切替時のダイアログ */}
                <Confirmation
                  visible={
                    this.state.dialogStatus ===
                    DIALOG_STATUS.leaveThisPageDialogEnabled.id
                  }
                  title={messageUtility.getMessage('I-000-051')}
                  confirmButtonText={messageUtility.getMessage('I-000-053')}
                  cancelButtonText={messageUtility.getMessage('I-000-008')}
                  message={messageUtility.getMessage('I-000-052')}
                  isNegative
                  onConfirm={() => {
                    if (this.state.selectedTabId) {
                      _masterSlideLoader.show(this.state.selectedTabId, {
                        state: {},
                      });
                    } else {
                      this.moveBack();
                    }
                  }}
                  onCancel={() => this.closeDialog()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const SideMenu = ({ handlerUserTabClick }) => (
  <div className='contruction-detail-view__sidemenu'>
    <ul className='contruction-navi-list'>
      <li className='contruction-navi-list__item'>
        <a
          className='line-list line-list--contruction-navi-list'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            handlerUserTabClick('UserProfileDetail');
          }}
        >
          基本情報
        </a>
      </li>
      <li className='contruction-navi-list__item'>
        <a className='line-list line-list--contruction-navi-list select'>
          顔写真
        </a>
      </li>
      <li className='contruction-navi-list__item'>
        <a
          className='line-list line-list--contruction-navi-list'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            handlerUserTabClick('UserProfileNotify');
          }}
        >
          通知設定
        </a>
      </li>
      <li className='contruction-navi-list__item'>
        <div
          className='line-list line-list--contruction-navi-list'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            _masterSlideLoader.show('UserProfileSettingMail', { state: {} });
          }}
        >
          メール受信設定
        </div>
      </li>
    </ul>
  </div>
);

// 定数
const data = {
  buttonLink: {
    label: '閉じる',
    defaultClassName: 'btn-text--sm',
  },
  defaultButton: {
    label: '',
    className: 'btn',
  },
  header: {
    confirm: {
      button: {
        edit: {
          label: '編集',
          className: 'btn',
        },
      },
    },
    edit: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        update: {
          label: '更新',
          className: 'btn--effective',
        },
      },
    },
  },
  successDialog: {
    title: '顔写真更新完了',
    message: '顔写真の更新が完了しました。',
    buttonText: '閉じる',
  },
  pageExplanation: '入退場管理の顔認証で使用する画像を登録できます。',
};



// WEBPACK FOOTER //
// ./src/pages/UserProfilePhoto.jsx